import { Option } from '../../../components/Form/Inputs/AutocompleteInput'
import { WorkEntry } from '../utils/WorklogTypes'
import { getDurationString } from '../../utils/worklogUtils'

export type WorklogEntryFormValues = {
  hours: string
  project: Option | null
  description: string
  remote: boolean | null
}

export const getDefaultWorklogEntryValues = (
  editedEntry: WorkEntry | null,
  remoteWorkModeFlag: boolean,
  defaultProject: Option | null
) => ({
  hours: editedEntry ? getDurationString(editedEntry.hours) : '',
  project: editedEntry ? { value: editedEntry.project.id, label: editedEntry.project.name } : defaultProject,
  description: editedEntry ? editedEntry.description : '',
  remote: editedEntry ? editedEntry.remote : remoteWorkModeFlag,
})